import { defineStore } from "pinia";
import { IPermissions, IUser } from "@/types";
import { reactive } from "vue";
import axios from "axios";
import { apiGetPermissions } from "@/api/permissions-api";
import { notify } from "@/package/helpers/notify";

export const usePermissionsStore = defineStore("permissions", () => {
  const permissions = reactive<IPermissions[]>([]);

  const fetchPermissions = async () => {
    try {
      const { data } = await apiGetPermissions();
      permissions.push(...data.data);
      // permissions.push({
      //   permission: Permission.ADMIN_COURIER_REQUEST_SHOW,
      //   group: "Заказ",
      //   groupSlag: "Order",
      //   title: "Просмотр курьерских заявок",
      //   parent: [],
      // });
      //
      // permissions.push({
      //   permission: Permission.ADMIN_COURIER_REQUEST_EDIT,
      //   group: "Заказ",
      //   groupSlag: "Order",
      //   title: "Управление курьерскими заявками",
      //   parent: [Permission.ADMIN_COURIER_REQUEST_SHOW],
      // });
    } catch (error) {
      if (axios.isAxiosError(error)) {
        notify(
          "error",
          "Ошибка",
          (error as Error).message || "Не удалось загрузить данные"
        );
        return Promise.reject(error.response?.data.message || error.message);
      }
    }
  };

  const getPermissions = (user: IUser): string[] => {
    return (
      user.roles?.flatMap(
        (role) => role.permissions?.map((p) => p.name) ?? []
      ) ?? []
    );
  };

  const can = (user: IUser | null, requiredPermission: string): boolean => {
    if (!user) {
      return false;
    }
    if (user.super_admin) {
      return true;
    }
    return getPermissions(user).includes(requiredPermission);
  };

  return {
    permissions,
    can,
    fetchPermissions,
  };
});
